import * as React from 'react';
import $ from "jquery";
import Common from '../../utilities/common';
import { Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField } from '@mui/material';
import { User } from './User';

export interface IUserEditProps {
    open: boolean;
    onClose?: Function;
    onSave?: Function;
    selectedItem: User | undefined;
}

export interface IUserEditState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
}

export default class UserEdit extends React.Component<IUserEditProps, IUserEditState> {
    _user: User = new User();
    _id: number = -1;
    
    public constructor(props: IUserEditProps) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: ''
        }
    }

    componentWillReceiveProps(nextProps: Readonly<IUserEditProps>, nextContext: any): void {
        if(nextProps.selectedItem != null) {
            this._user = nextProps.selectedItem;
        }

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    Modificar usuario
                </DialogTitle>
                <DialogContent>
                    {
                        this.state.hasErrors && (
                            <Alert severity="error" style={{marginBottom: '10px'}}>
                                {
                                    this.state.errorMessage
                                }
                            </Alert>
                        )
                    }
                    <Box>
                        <FormControl fullWidth style={{marginBottom: '20px'}}>
                            <TextField required variant='standard' label='Nombre' defaultValue={this._user.nombre} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                if(event.target.value == '') {
                                    this.setState(
                                        {
                                            hasErrors: true,
                                            errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                        }
                                    );
                                }
                                else {
                                    this.setState(
                                        {
                                            hasErrors: false,
                                            errorMessage: ''
                                        }
                                    );
                                    this._user.nombre = event.target.value;
                                }
                            }}></TextField>
                        </FormControl>
                        <FormControl fullWidth style={{marginBottom: '20px'}}>
                            <TextField required variant='standard' label='Apellidos' defaultValue={this._user.apellidos} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                if(event.target.value == '') {
                                    this.setState(
                                        {
                                            hasErrors: true,
                                            errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                        }
                                    );
                                }
                                else {
                                    this.setState(
                                        {
                                            hasErrors: false,
                                            errorMessage: ''
                                        }
                                    );
                                    this._user.apellidos = event.target.value;
                                }
                            }}></TextField>
                        </FormControl>
                        <FormControl fullWidth style={{marginBottom: '20px'}}>
                            <TextField required variant='standard' label='Email' defaultValue={this._user.userName} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                if(event.target.value == '') {
                                    this.setState(
                                        {
                                            hasErrors: true,
                                            errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
                                        }
                                    );
                                }
                                else {
                                    this.setState(
                                        {
                                            hasErrors: false,
                                            errorMessage: ''
                                        }
                                    );
                                    this._user.userName = event.target.value;
                                }
                            }}></TextField>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.Update.bind(this)}>OK</Button>
                    <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    private Close() {
        this.setState(
            {
                open: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Update() {
        if(this._user.nombre == '' || this._user.nombre == null) {
            this.setState({
                hasErrors: true,
                errorMessage: 'Introduzca los valores correspondientes en los campos obligatorios o seleccione un archivo.'
            })
            return;
        }

        let url = `${Common.END_POINT}/masters/users/${this._user.id}/update`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._user),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done(() => {
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._user = new User();
        }).fail((jqXHR, textStatus, errorThrown) => {
            this.setState(
                {
                    open: false
                }
            );
    
            if(this.props.onSave != null) {
                this.props.onSave();
            }

            this._user = new User();
        });
    }
}